<template>
  <div class="task taskButton taskHtmlPdf">
    <button v-on:click="callTaskService()" type="button" class="w3-buttonTask">
      <transition name="fade" mode="out-in">
        <spinner-loading v-if="taskLoading" class="spinner-loading" :line-size='2' :size="18" line-fg-color='#5dbecd' />
        <i v-else :class="['sherpa-icon', 'icon-' + task.taskId]"></i>
      </transition>
      <span>{{ task.label }}</span>
    </button>
    <div class="message">
      <transition name="fade" mode="out-in">
        <span v-if="!taskLoading && taskError" class="label error_validate"> {{ getLang('taskError') }} </span>
        <span v-else-if="!taskLoading && taskResp && taskResp !== ''" class="label ok_validate"> {{ taskResp }} </span>
      </transition>
    </div>
  </div>
</template>

<script>
import * as api from '../../utils/definitionApi'
import SpinnerLoading from 'vue-simple-spinner'
import language from '../../language'

// https://github.com/eKoopmans/html2pdf.js
import html2pdf from 'html2pdf.js'

export default {
  name: 'definition-task-html-pdf',
  props: [
    'task',
    'definition',
    'object',
    'taskRefresh',
    'definitionContentId',
    'repeatableGroupCode',
    'languageSelected',
    'language',
    'authorization',
    'type',
    'repeatableItemIndex',
    'calledTaskIndex',
    'callTask'
  ],
  data () {
    return {
      taskError: false,
      taskResp: '',
      taskLoading: false
    }
  },
  components: {
    SpinnerLoading
  },
  methods: {
    callTaskService () {
      this.taskLoading = true
      setTimeout(() => {
        api.call({domainEndpoint: this.type.domainEndpoint, url: this.task.type.endpoint, token: this.type.token, version: this.type.version, method: 'POST', lang: this.getLang(), authorization: this.authorization, data: { id: this.definitionContentId, code: this.repeatableGroupCode, requestObject: this.object }})
          .then(resp => {
            this.taskError = false
            this.taskLoading = false

            if (resp.requestResult) {
              this.taskResp = resp.requestResultSuccess

              if (resp.requestObject && resp.requestObject.length > 0) {
                var html = resp.requestObject[0].textValue
                var opt = {
                  margin: [10, 10, 10, 10],
                  filename: `document.pdf`,
                  image: { type: 'jpeg', quality: 0.98 },
                  html2canvas: { scale: 2, useCORS: true },
                  jsPDF: { unit: 'mm', format: 'letter', orientation: 'portrait' }
                }
                // for open in new window
                html2pdf().from(html).set(opt).toPdf().get('pdf').then(function (pdf) {
                  window.open(pdf.output('bloburl'), '_blank')
                })
                // for download
                // html2pdf().from(html).set(opt).save()
              }
            }
          })
          .catch(err => {
            console.log(err)
            this.taskError = true
            this.taskLoading = false
          })
      }, 500)
    },
    getLang (key) {
      return language(this.language, key)
    }
  },
  watch: {
    calledTaskIndex: {
      handler: function (val) {
        this.callTaskService()
      },
      deep: true
    },
    callTask: {
      handler: function (val) {
        if (val.id === this.task.taskId) {
          this.callTaskService()
        }
      },
      deep: true
    }
  }
}
</script>

<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/components/content/definitionLoader/item/task/taskHtmlPdf.vue